import { type Task, TaskSchema } from '../model/schema'

export interface ReminderDto {
  id: string
  lead_seconds?: number
  remind_at?: string
  created_at: string
}

export interface TaskDto {
  id: string
  board_id: string
  column_id: string
  parent_id?: string
  title: string
  description?: string
  type: string
  assignee_id?: string
  assigned_by?: string
  assigned_at?: string
  due_date?: string
  due_time?: string
  reminders?: ReminderDto[]
  priority?: number
  complexity?: number
  estimate_hours?: number
  actual_complexity?: number
  bug_details?: { steps_to_reproduce: string }
  position?: number
  blocked?: boolean
  blocking?: boolean
  active_employee_id?: string
  customer_visible?: boolean
  customer_visible_by?: string
  customer_visible_at?: string
  company_id?: string
  project_id?: string
  archived: boolean
  archived_at?: string
  created_by?: string
  created_by_customer?: string
  created_at: string
  updated_at: string
}

function toReminder(dto: ReminderDto) {
  return {
    id: dto.id,
    leadSeconds: dto.lead_seconds ?? null,
    remindAt: dto.remind_at ?? null,
    createdAt: dto.created_at,
  }
}

export function toTask(dto: TaskDto): Task {
  return TaskSchema.parse({
    id: dto.id,
    boardId: dto.board_id,
    columnId: dto.column_id,
    parentId: dto.parent_id ? dto.parent_id : null,
    title: dto.title,
    description: dto.description ?? '',
    type: dto.type,
    assigneeId: dto.assignee_id ? dto.assignee_id : null,
    assignedBy: dto.assigned_by ? dto.assigned_by : null,
    assignedAt: dto.assigned_at ?? null,
    dueDate: dto.due_date ?? null,
    dueTime: dto.due_time ?? null,
    // Отсутствие поля и пустой набор различаются: списки за напоминаниями не
    // ходят вовсе, карточка отдаёт их всегда.
    ...(dto.reminders ? { reminders: dto.reminders.map(toReminder) } : {}),
    priority: dto.priority ?? null,
    complexity: dto.complexity ?? null,
    estimateHours: dto.estimate_hours ?? null,
    actualComplexity: dto.actual_complexity ?? null,
    bugDetails: dto.bug_details ? { stepsToReproduce: dto.bug_details.steps_to_reproduce } : null,
    ...(dto.position !== undefined ? { position: dto.position } : {}),
    ...(dto.blocked !== undefined ? { blocked: dto.blocked } : {}),
    ...(dto.blocking !== undefined ? { blocking: dto.blocking } : {}),
    activeEmployeeId: dto.active_employee_id ? dto.active_employee_id : null,
    // Нет поля — считаем «не открыта клиенту»: безопасный дефолт, пока источник
    // не выкатил флаг (00-architecture § 5).
    customerVisible: dto.customer_visible ?? false,
    customerVisibleBy: dto.customer_visible_by ? dto.customer_visible_by : null,
    customerVisibleAt: dto.customer_visible_at ?? null,
    companyId: dto.company_id ? dto.company_id : null,
    projectId: dto.project_id ? dto.project_id : null,
    archived: dto.archived,
    archivedAt: dto.archived_at ?? null,
    createdBy: dto.created_by ? dto.created_by : null,
    createdByCustomer: dto.created_by_customer ? dto.created_by_customer : null,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
  })
}
